import { FPageFlag } from '../mdl/f-page';
import { FPageContainerBlock, FPageHSplitBlock } from '../mdl/f-page-block';
import { uiSetBG } from '../ui/bg';
import { $el } from '../ui/elements';
import { YFlags } from '../y/types';
import { blkRegister } from './registry';
import { makePageBlock } from './render';

function makeContainerBlock(b: FPageContainerBlock, section: HTMLElement, promises: Promise<any>[], id: string, page_flags: YFlags<FPageFlag>) {
    const bg = $el.DIV('r-bg');
    uiSetBG(bg, b.bg);

    return $el.DIV(['blk-container', 'k-' + b.kind], $el.DIV('r-content', [
        bg,
        $el.DIV('r-container', b.blocks.map(bb => makePageBlock(bb, section, promises, id, page_flags)))
    ]));
}

blkRegister<FPageContainerBlock>('container', makeContainerBlock);

blkRegister<FPageHSplitBlock>('hsplit', (b, section, promises, id, page_flags) => {
    return $el.DIV(['blk-hsplit b b-block', b.reverse && 'm-reverse', 'm-wrap-' + b.wrap, 'm-align-' + b.align], [
        $el.DIV('r-left', makeContainerBlock(b.blocks[0], section, promises, id + '-l', page_flags)),
        $el.DIV('r-right', makeContainerBlock(b.blocks[1], section, promises, id + '-r', page_flags)),
    ]);
})
